<template>
  <div class="md:p-6 p-0 md:pt-6 pt-4 overflow-y-scroll scroll-smooth no-scrollbar bg-gray-50/50 min-h-screen">
    <div v-if="$app.userInfo?.is_active">
      <div class="fixed z-10 left-0 top-[60px] md:top-[64px] w-full bg-white/80 backdrop-blur-md flex justify-center p-3 border-b border-gray-200 shadow-[0_2px_10px_rgba(0,0,0,0.02)] transition-transform duration-300"
        :class="showHeaderTabs ? 'translate-y-0' : '-translate-y-[150%]'"
      >
        <div class="relative overflow-hidden rounded-xl bg-gray-100/70 p-1.5 w-full max-w-5xl mx-auto border border-gray-200/50 flex items-center">
          <div class="relative grid grid-cols-4 font-medium text-center text-gray-500 text-[11px] sm:text-[13px] md:text-[15px] w-full items-center">
            <div class="absolute top-0 bottom-0 my-auto h-full bg-white rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-gray-200/50 transition-all duration-500 ease-out z-0"
              :style="underlineStyle"></div>
            <div v-for="(item, index) in tabs" :key="index" @click="fillDataNav(item,index)"
              class="py-2.5 flex items-center justify-center cursor-pointer transition-all duration-300 z-10 relative rounded-lg"
              :class="{ 'text-brand font-bold': activeIndex === index, 'hover:text-gray-800': activeIndex !== index }">
              <el-badge v-if="badgesTab(item.value) !== 0" :value="badgesTab(item.value)" class="item">
                <div>
                  {{ item.name }}
                </div>
              </el-badge>
              <div v-else> {{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col lg:flex-row lg:items-center justify-between mt-5 pt-[50px] gap-0 lg:gap-3 transition-all duration-300 px-2 lg:px-0" :class="showHeaderTabs ? 'pt-[50px]' : 'pt-0'">
        <div class="flex overflow-x-auto md:flex-wrap btngroup gap-2 pb-2 md:pb-0 no-scrollbar w-full md:w-auto snap-x">
            <el-button type="primary" plain icon="el-icon-document" @click="openNotePopup('Thêm phiếu')" class="shadow-[0_2px_4px_rgba(0,0,0,0.05)] font-medium md:font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0 shrink-0 h-8 md:h-[34px] !py-0 !px-2.5 md:!px-3 text-[12px] md:text-[13px] flex items-center justify-center snap-start whitespace-nowrap">
              Tạo phiếu
            </el-button>

            <el-button type="success" plain icon="el-icon-refresh-left" @click="reloadPage()" class="shadow-[0_2px_4px_rgba(0,0,0,0.05)] font-medium md:font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0 shrink-0 h-8 md:h-[34px] !py-0 !px-2.5 md:!px-3 text-[12px] md:text-[13px] flex items-center justify-center snap-start whitespace-nowrap">
              Tải lại
            </el-button>

            <el-button v-if="showSignMultipleButton" type="primary" plain @click="signMultiple()" class="shadow-[0_2px_4px_rgba(0,0,0,0.05)] font-medium md:font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0 shrink-0 h-8 md:h-[34px] !py-0 !px-2.5 md:!px-3 text-[12px] md:text-[13px] flex items-center justify-center snap-start whitespace-nowrap">
              <span class="flex items-center gap-1.5"><font-awesome-icon :icon="['fas', 'file-signature']" /> Ký hàng loạt</span>
            </el-button>
            <el-button v-if="showExportExcel" type="info" plain @click="exportExcel()" class="shadow-[0_2px_4px_rgba(0,0,0,0.05)] font-medium md:font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0 shrink-0 h-8 md:h-[34px] !py-0 !px-2.5 md:!px-3 text-[12px] md:text-[13px] flex items-center justify-center snap-start whitespace-nowrap">
              <span class="flex items-center gap-1.5"><font-awesome-icon :icon="['fas', 'file-export']" /> Xuất Excel</span>
            </el-button>
            <el-button v-if="showExportExcel" type="warning" plain @click="downloadExcel()" class="shadow-[0_2px_4px_rgba(0,0,0,0.05)] font-medium md:font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200 !ml-0 shrink-0 h-8 md:h-[34px] !py-0 !px-2.5 md:!px-3 text-[12px] md:text-[13px] flex items-center justify-center snap-start whitespace-nowrap">
              <span class="flex items-center gap-1.5"><font-awesome-icon :icon="['fas', 'file-export']" /> Xuất Excel rà soát</span>
            </el-button>
        </div>
        
        <div class="flex items-center justify-center font-bold text-gray-800 text-[13px] md:text-[14px] bg-white px-3 md:px-4 h-8 md:h-[34px] rounded-lg shadow-sm border border-gray-100/50 w-fit shrink-0 lg:ml-auto lg:mx-0 mb-2 lg:mb-0 box-border" v-if="$app.userInfo.user_role.value === 0 || $app.userInfo.user_role.value === 1 || $app.userInfo.user_role.value === 3 && $app.userInfo.departments?.some(el => el.value === 3)">
          <span>
            <span class="text-gray-500 font-medium mr-1">Tổng tiền:</span> <span class="text-brand tracking-wide">{{ formatVND($app.totalExpense) }}</span>
          </span>
        </div>
      </div>
      <div class="md:mt-2">
        <TablePaymentcomponent :tablepaymentHeader="tableHeader" @reload="reloadPage()" ref="undateData"
          :fillDataNumber="$app.fillDataNumber" />
      </div>
      <NotePaymentpopup v-if="isShowNotePopup" :isShow="isShowNotePopup" @closed="isShowNotePopup = false"
        :nameHeader="titlePopup" @reload="reloadPage()" />
      <Check2FA v-if="isShowCheck2FAPopup" :isShow="isShowCheck2FAPopup" @closed="onClosedCheck2FA"
        :isSignMultiple="true" />
      <FillterExcelData v-if="isShowFillterExcelData" :options="options" :isShow="isShowFillterExcelData"
        :tabNumber="$app.fillDataNumber" @closed="isShowFillterExcelData = false" />
    </div>
    <NotificationPopup v-if="isShowNotificationPopup" :isShow="isShowNotificationPopup" ref="notificationPopup" />
  </div>
</template>

<script>
import TablePaymentcomponent from '../component/TablePaymentcomponent.vue';
import NotePaymentpopup from '../popup/NotePaymentpopup.vue'
import Check2FA from '../popup/Check2FA.vue'
import FillterExcelData from '../popup/FillterExcelData.vue';
import NotificationPopup from '../popup/NotificationPopup.vue';

const API_URL = process.env.VUE_APP_API_URL
export default {
  components: {
    NotePaymentpopup,
    TablePaymentcomponent,
    Check2FA,
    FillterExcelData,
    NotificationPopup
  },
  data() {
    return {
      isShowNotificationPopup: false,
      tabs: [
        { name: 'Xem xét', value: 0 },
        { name: 'Phê duyệt', value: 1 },
        { name: 'Đã chi', value: 2 },
        { name: 'Từ chối', value: 3 },
      ],
      activeIndex: 0,
      isShowCheck2FAPopup: false,
      typePopup: "",
      tableHeader: ["Mã phiếu", "Loại phiếu", "Bộ phận", "Địa chỉ", "Phương thức", "Tổng tiền", "Trạng thái"],
      isShowNotePopup: false,
      titlePopup: "",

      isShowFillterExcelData: false,
      showHeaderTabs: true,
      lastScrollPosition: 0,
      scrollCheckInterval: null, // Added for the interval
    };
  },
  mounted() {
    if (this.$app.userInfo && !this.$app.userInfo.is_active) {
      this.isShowNotificationPopup = true
    }
    // Set up a global interval to check scroll wrapper if event listener fails
    this.scrollCheckInterval = setInterval(this.checkScrollPosition, 50);
  },
  beforeDestroy() {
    if (this.scrollCheckInterval) {
      clearInterval(this.scrollCheckInterval);
    }
  },
  computed: {
    showSignMultipleButton() {
      return this.$app.multipleSelection.length && this.$app.userInfo.user_role.value !== 3
    },
    showExportExcel() {
      return this.$app.userInfo.departments.some(el => el.value === 3)
    },
    underlineStyle() {
      const width = 100 / this.tabs.length;
      return {
        width: width + '%',
        left: this.activeIndex * width + '%',
      };
    },
  },
  methods: {
    checkScrollPosition() {
      // Find the active scroll container. It's usually the vue wrapper or table body
      const scrollContainer = document.querySelector('.overflow-y-scroll') || document.documentElement;
      const tableContainer = document.querySelector('.el-table__body-wrapper');
      
      let currentScrollPosition = 0;
      
      if (tableContainer && tableContainer.scrollTop > 5) {
        currentScrollPosition = tableContainer.scrollTop;
      } else {
        currentScrollPosition = scrollContainer.scrollTop || window.scrollY;
      }

      if (currentScrollPosition <= 0) {
        if (!this.showHeaderTabs) this.showHeaderTabs = true;
        this.lastScrollPosition = currentScrollPosition;
        return;
      }
      
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 5) {
        return;
      }

      const newShowState = currentScrollPosition < this.lastScrollPosition;
      if (newShowState !== this.showHeaderTabs) {
        this.showHeaderTabs = newShowState;
      }
      this.lastScrollPosition = currentScrollPosition;
    },
    formatVND(amount) {
      return parseInt(amount).toLocaleString("vi-VN", { style: "currency", currency: "VND" })
    },
    badgesTab(item) {
      return item === 0 ? this.$app.summary.totalPending : (item === 1 ? this.$app.summary.totalApproved : (item === 3 ? this.$app.summary.totalRejected : ''))
    },
    onClosedCheck2FA() {
      this.isShowCheck2FAPopup = false
      this.reloadPage()
    },
    fillDataNav(item,index) {
      this.activeIndex = index;
      this.$app.fillDataNumber = item.value
      setTimeout(() => {
        this.reloadPage()
      }, 200);
    },
    openNotePopup(value) {
      this.isShowNotePopup = true
      this.titlePopup = value
    },
    reloadPage() {
      this.$refs.undateData.getAllBill()
    },
    signMultiple() {
      this.isShowCheck2FAPopup = true
    },
    exportExcel() {
      this.isShowFillterExcelData = true
    },
    async downloadExcel() {
      try {
        const dateRange = this.$app.selectedDateRange;
        const response = await this.$axios.post(
          `${API_URL}/bills/export-review`,
          {
            dateRange: dateRange,
            reviewed: this.$app.reviewed
          },
          {
            responseType: "blob",
            headers: {
              "X-Authorization": `Bearer ${this.$app.token}`,
            },
          }
        );

        // Tạo file download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "review_bills.xlsx";
        a.click();

      } catch (err) {
        console.error("❌ Lỗi tải Excel:", err);
      }
    }

  },
};
</script>


<style lang="scss">
.el-autocomplete-suggestion {
  min-width: 400px !important;
  /* 👈 rộng hơn input */
  padding-bottom: 10px !important;
}

.el-select-dropdown__list {
  margin-bottom: 10px !important;
}

.btngroup {
  overflow-x: scroll;

  .el-button {
    width: fit-content;
    padding: 8px 12px;
  }
}

.actiFillData {
  color: #4b5563;
  border-bottom: 4px solid #1865b1;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
  /* Ẩn trên Chrome, Safari */
}

.no-scrollbar {
  -ms-overflow-style: none;
  /* Ẩn trên IE, Edge */
  scrollbar-width: none;
  /* Ẩn trên Firefox */
}

@keyframes popupFadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes popupFadeOut {
  0% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(10px);
  }
}

.animate-popupFadeIn {
  animation: popupFadeIn 0.5s forwards;
}

.animate-popupFadeOut {
  animation: popupFadeOut 0.5s forwards;
}
</style>